import React, { useState } from "react";
import Wrapper from "../components/Wrapper";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { translations } from "../langauge";
import MobileBottomMenu from "../components/MobileBottomMenu";

const TEAM_MEMBER_IDS = [
  "basil",
  "mohammad",
  "talal",
  "fahad",
  "noor",
  "vincent",
  "smile",
];

const TEAM_MEMBER_IMAGES = {
  basil: "./images/team/master_Basil.png",
  mohammad: "./images/team/worlock_mohammed.png",
  talal: "./images/team/fearless_TalalSaab.png",
  fahad: "./images/team/phantom_Fahad.png",
  noor: "./images/team/xpert_Noor.png",
  vincent: "./images/team/cerebral_Vivek.png",
  smile: "./images/team/anonymous_SmileMettel.gif",
};

const Team = () => {
  const { lang } = useLang();
  const navigate = useNavigate();
  const [activeMember, setActiveMember] = useState("basil");

  const sideNavItems = [
    {
      id: "go-back",
      title: translations[lang].go_back,
      isBack: true,
    },
    ...TEAM_MEMBER_IDS.map((id) => ({
      id,
      title: translations[lang][`team_${id}_name`],
      isBack: false,
    })),
  ];

  const currentMember = activeMember;
  const sectionIndex = TEAM_MEMBER_IDS.indexOf(activeMember);
  const safeSectionIndex = sectionIndex >= 0 ? sectionIndex : 0;
  const memberName = translations[lang][`team_${currentMember}_name`];

  const handlePrevMember = () => {
    const prevIndex = (safeSectionIndex - 1 + TEAM_MEMBER_IDS.length) % TEAM_MEMBER_IDS.length;
    setActiveMember(TEAM_MEMBER_IDS[prevIndex]);
  };
  const handleNextMember = () => {
    const nextIndex = (safeSectionIndex + 1) % TEAM_MEMBER_IDS.length;
    setActiveMember(TEAM_MEMBER_IDS[nextIndex]);
  };
  const memberAlias = translations[lang][`team_${currentMember}_alias`];
  const memberRole = translations[lang][`team_${currentMember}_role`];
  const memberSkills = translations[lang][`team_${currentMember}_skills`];
  const memberDescription =
    translations[lang][`team_${currentMember}_description`];
  const memberImage = TEAM_MEMBER_IMAGES[currentMember];

  return (
    <Wrapper>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-4 rightSideDivParent">
          <div
            className="rightSideDiv"
          >
            <div className="navbarDiv">
              <ul>
                {sideNavItems.map((item) => (
                  <li key={item.id}>
                    {item.isBack ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/");
                        }}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="go back"
                          src="./images/left-arrow.png"
                          style={{
                            marginRight: lang === "en" ? "15px" : 0,
                            marginLeft: lang === "ar" ? "15px" : 0,
                            height: "20px",
                            width: "auto",
                            display: "flex",
                            alignItems: "center",
                            transform: lang === "ar" ? "rotate(180deg)" : undefined,
                          }}
                        />
                        {item.title}
                      </a>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveMember(item.id);
                        }}
                        className={activeMember === item.id ? "active" : ""}
                        style={{ textAlign: lang === "ar" ? "right" : "left" }}
                      >
                        {item.title}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-8 contentDivParent">
          <div className="contentDiv">
            <h2
              className="aboutSectionTitle"
              style={{ textAlign: lang === "ar" ? "right" : "left" }}
            >
              {memberName}
            </h2>
            <div className="teamMemberDetailContainer">
              <div className="teamMemberTopSection">
                <div className="teamMemberImageWrapper">
                  <img
                    alt={memberName}
                    className="teamMemberImage"
                    src={memberImage}
                  />
                </div>
                <div className="teamMemberAttributes">
                  <div className="teamAttribute">
                    <strong>{translations[lang].team_known_alias}</strong> [
                    {memberAlias}]
                  </div>
                  <div className="teamAttribute">
                    <strong>{translations[lang].team_role}</strong> [
                    {memberRole}]
                  </div>
                  <div className="teamAttribute">
                    <strong>{translations[lang].team_skills}</strong> [
                    {memberSkills}]
                  </div>
                </div>
              </div>
              <p
                className="commonpara teamMemberDescription"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                {memberDescription}
              </p>
            </div>
          </div>
        </div>
      </div>
      <MobileBottomMenu
        title={memberName}
        withTabs
        sectionIndex={safeSectionIndex}
        sectionCount={TEAM_MEMBER_IDS.length}
        onPrev={handlePrevMember}
        onNext={handleNextMember}
      />
    </Wrapper>
  );
};

export default Team;
